<!--
  我的收藏
  creat at 2020年4月3日09:19:33 by zcg
-->
<template>

  <div id="IDContaienr">

    <van-pull-refresh v-if=" favourateList.length != 0" v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="1">
        <div class="item-box">
          <van-row class="list">
            <!-- <div v-for="(item,i) in favourateList" :key="i">111</div> -->
            <favouratecell v-for="(item,idx) in favourateList" :icon="item.picUrl" :key="idx" :title="item.name" :id="item.valueId" :subtitle="item.brief" :price="item.retailPrice" @click="cellClick"></favouratecell>

          </van-row>
        </div>
      </van-list>
    </van-pull-refresh>
    <div v-else>
      <img class="no-data-img" src="../../assets/index/no_list.png" alt="">
      <div class="no-data-text">还没有收藏哦，快去收藏吧！</div>
    </div>
  </div>

</template>





<script>
import favouratecell from "../../components/favouratecell";
import { collectList } from "@/api/index";
import { Toast, Dialog } from "vant";

export default {
  name: "favourate",
  components: { favouratecell },
  data() {
    return {
      dataInfo: {
        type: 0,
        page: 1,
        size: 10
      },
      isLoading: true,
      loading: false,
      finished: false,
      favourateList: []
    };
  },
  mounted() {
    document.getElementById("IDContaienr").style.height =
      document.body.clientHeight - 60 + "px";
    this.dataInfo = {
      type: 0,
      page: 1,
      size: 10
    };
    this.getList();
  },
  methods: {
    cellClick(goodIDs) {
      this.$router.push({
        path: "/type/detail",
        query: { id: goodIDs }
      });
    },
    onRefresh() {
      setTimeout(() => {
        Toast("刷新成功");
        this.isLoading = false;

        this.dataInfo = {
          type: 0,
          page: 1,
          size: 10
        };
        this.favourateList = [];
        this.getList();
        this.finished = false;
      }, 500);
    },
    onLoad() {
      setTimeout(() => {
        // 异步更新数据
        const nextPaging = {
          page: this.dataInfo.page + 1,
          size: 10,
          type: 0
        };
        this.dataInfo = nextPaging;
        this.getList(this.dataInfo);
      }, 500);
    },
    getList() {
      collectList(this.dataInfo).then(res => {
        console.log(res);
        if (res.data.errno == 0) {
          let newOfRes = JSON.parse(JSON.stringify(res.data.data));
          this.favourateList = this.favourateList.concat(newOfRes.collectList);
          this.loading = false;
          // 数据全部加载完成
          if ((this.dataInfo.page = newOfRes.totalPages)) {
            this.finished = true;
          }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
    }
  }
};
</script>


<style scoped lang="scss">
#IDContaienr {
  background-color: white;
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  .no-data-img {
    width: 74%;
    margin: 6rem auto;
  }
  .no-data-text {
    font-family: PingFangSC-Semibold;
    font-size: 1.8rem;
    color: #424242;
    letter-spacing: 0;
    line-height: 1.8rem;
  }
}
/deep/ .van-pull-refresh,
.van-pull-refresh__track,
.van-list {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/person/favourate.vue